import React from 'react';

import { Button as AntdButton } from 'antd';

import { ComputedResponseDtoListAvailableFilesEnum } from 'lib_api/lib/api/gen';

import { availableFilesMapping } from 'utils/enumData';

interface SingleAvailableFileProps {
  file: ComputedResponseDtoListAvailableFilesEnum;
  downloadDocument: (file: ComputedResponseDtoListAvailableFilesEnum) => void;
  isDownloading: boolean;
}

const SingleAvailableFile = ({
  file,
  downloadDocument,
  isDownloading,
}: SingleAvailableFileProps): React.ReactElement => {
  return (
    <AntdButton
      onClick={() => {
        downloadDocument(file);
      }}
      type="default"
      shape="round"
      className="ActionsButton"
      loading={isDownloading}
    >
      {availableFilesMapping[file]}
    </AntdButton>
  );
};

export default SingleAvailableFile;
